import React from "react";
import styled from "styled-components";
import { BE_ADDR } from "../../../api/host";

const LogoImage = styled.img`
  width: ${props => props.welcomeLogo};
`

const LogoTop = ({link}) => {
    return <img
        className="img-header-center"
        src={`${BE_ADDR}${link}`}
    />
}

export default LogoTop